export const archiveInview = () => {
  // archive-body__user-contentの直下要素にinviewクラスを追加
  const userContentElement = document.querySelector(".js-archive-content");

  if (userContentElement && userContentElement.children.length > 0) {
    Array.from(userContentElement.children).forEach((child) => {
      child.classList.add("inview");
    });
  }
};
